
import { useState } from 'react';

export default function Hero() {
  const [phone] = useState('(682) 600-1829');

  return (
    <div 
      className="relative min-h-screen bg-cover bg-center bg-no-repeat bg-gray-900"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/f3f21e95b6633c13ce1504a7d22d5ec0.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
      
      <div className="relative z-10 w-full px-6 lg:px-8">
        {/* Navigation */}
        <nav className="flex items-center justify-between py-6">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-white tracking-wide" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              YOUNG GUNS PEST CONTROL
            </h1>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className="text-white hover:text-green-400 transition-colors cursor-pointer">Services</a>
            <a href="#about" className="text-white hover:text-green-400 transition-colors cursor-pointer">About</a>
            <a href="#testimonials" className="text-white hover:text-green-400 transition-colors cursor-pointer">Reviews</a>
            <a href="#contact" className="text-white hover:text-green-400 transition-colors cursor-pointer">Contact</a>
            <a href={`tel:${phone}`} className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
              Call Now
            </a>
          </div>
        </nav>

        {/* Hero Content */}
        <div className="flex items-center min-h-[calc(100vh-120px)]">
          <div className="w-full max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6">
              Professional Pest Control You Can Trust
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
              Protect your home and family with our safe, effective pest control solutions. Licensed, insured, and committed to your satisfaction.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
                Get Free Quote
              </button>
              <a 
                href={`tel:${phone}`}
                className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Call {phone}
              </a>
            </div>
            
            {/* Features */}
            <div className="flex flex-wrap gap-6 mt-12">
              <div className="flex items-center text-white">
                <div className="w-6 h-6 flex items-center justify-center mr-3">
                  <i className="ri-shield-check-line text-green-400 text-xl"></i>
                </div>
                <span className="text-lg">Licensed & Insured</span>
              </div>
              <div className="flex items-center text-white">
                <div className="w-6 h-6 flex items-center justify-center mr-3">
                  <i className="ri-time-line text-green-400 text-xl"></i>
                </div>
                <span className="text-lg">24/7 Emergency Service</span>
              </div>
              <div className="flex items-center text-white">
                <div className="w-6 h-6 flex items-center justify-center mr-3">
                  <i className="ri-leaf-line text-green-400 text-xl"></i>
                </div>
                <span className="text-lg">Eco-Friendly Solutions</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
